// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1vg2Ubu0rzwaSj {\n  display: flex;\n  flex-direction: row;\n}\n._1vg2Ubu0rzwaSj li {\n  margin-top: 2px;\n  margin-right: 6px;\n}\n._1vg2Ubu0rzwaSj li:first-of-type {\n  margin-right: 4px;\n}\n._1vg2Ubu0rzwaSj li:first-of-type img {\n  width: 21px;\n}\n._1vg2Ubu0rzwaSj li,\n._1vg2Ubu0rzwaSj li a {\n  width: 24px;\n  height: 24px;\n}\n._1vg2Ubu0rzwaSj li a {\n  display: flex;\n  align-items: center;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"socialShareLinksList": "_1vg2Ubu0rzwaSj"
};
export default ___CSS_LOADER_EXPORT___;
